import { render, staticRenderFns } from "./moblieScreen.vue?vue&type=template&id=b94ec748&scoped=true"
import script from "./moblieScreen.vue?vue&type=script&lang=js"
export * from "./moblieScreen.vue?vue&type=script&lang=js"
import style0 from "./moblieScreen.vue?vue&type=style&index=0&id=b94ec748&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b94ec748",
  null
  
)

export default component.exports